import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ArrowRightIcon } from 'lucide-react';
export function FinalCTA() {
  return <section className="bg-white py-24 px-6" data-id="element-64">
      <div className="max-w-3xl mx-auto text-center" data-id="element-65">
        <FadeIn data-id="element-66">
          <h2 className="font-serif text-3xl md:text-4xl text-[#1B2A4A] mb-8" data-id="element-67">
            Si hoy estás en ese punto donde tu intuición no se calla,{' '}
            <span className="italic text-[#3BBFAD]" data-id="element-68">no lo negocies.</span>
          </h2>

          <p className="text-xl text-[#1B2A4A]/80 mb-12" data-id="element-69">
            No esperes “a ver”.
            <br data-id="element-70" />
            Descarga La Ruta Clara y en menos de una hora vas a tener:
            <br data-id="element-71" />
            <span className="font-bold text-[#1B2A4A] mt-2 block" data-id="element-72">
              claridad, un tracker, y un plan de 14 días.
            </span>
          </p>

          <a href="#pricing" className="inline-flex items-center gap-2 bg-[#1B2A4A] text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-[#2A3F66] hover:scale-105 transition-all duration-300 shadow-lg" data-id="element-73">
            Quiero mi Ruta Clara
            <ArrowRightIcon className="w-5 h-5" data-id="element-74" />
          </a>
        </FadeIn>
      </div>
    </section>;
}